import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

export type GetPlantConnectionCertificateResponse = {
  type: 'certificate-ca' | 'certificate-pem' | 'private-key';
  text: string;
};

export const useGetPlantConnectionCertificateQuery = ({
  onSuccess,
}: {
  onSuccess?: (data: {
    type: 'certificate-ca' | 'certificate-pem' | 'private-key';
    text: string;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      plantId,
      certificateType,
    }: {
      plantId: string | undefined;
      certificateType: 'certificate-ca' | 'certificate-pem' | 'private-key';
    }) => {
      const { data } = await client.get<{ body: GetPlantConnectionCertificateResponse }>(
        `/plants/${plantId}/connection-details/${certificateType}`
      );

      return data.body;
    },
    onSuccess: (data) => {
      if (data && onSuccess) onSuccess(data);
    },
  });
};
